import React from "react";
import axios from "axios";
import { Link } from "gatsby";
import { Container } from "react-bootstrap";
import LoadingContent from "../loading-content-1";

const records = [];

var Api_url = process.env.GATSBY_API_URL;
var url = Api_url + `/api/wm/yearwise/team/members/lists`;
console.log('API_URL=' + Api_url + ', url=' + url);

const axiosConfig = {
  headers: {
    "Content-Type": "application/json; text/html; charset=UTF-8",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept"
  },
};
class PaymentsPage extends React.Component {

  constructor() {
    super();
    this.state = {
      Records: records,
      LoadingFlag: false,
      TotalRecords: 0,
    }
  };

  getAllRecords = async () => {
    console.log("getAllRecords called ");
    var url = Api_url + `/api/app-settings-content`;
    console.log("url=" + url);
    var postData = {
      UserInterface: 1,
      AppName: "jci_india_website",
      SettingsName: "payment_links",
    };
    this.setState({ LoadingFlag: true });
    console.log("postData=" + JSON.stringify(postData));
    // this.setState({ isLoading: true });
    await axios
      .post(url, postData, axiosConfig)
      .then(res => {
        console.log("RESPONSE RECEIVED: ", res);
        console.log("res=" + JSON.stringify(res));

        var records = res.data.records;
        console.log({ records });
        var result = records.SettingsValues;
        var n1 = result.length;
        console.log("n1=" + n1);

        this.setState({ LoadingFlag: false, Records: result, TotalRecords: n1 });

      })
      .catch((err) => {
        console.log("AXIOS ERROR: ", err);
      });
  };

  componentDidMount() {
    console.log("componentDidMount called ");
    // window.location.replace('https://www.google.com')
    this.getAllRecords();
  }

  render() {
    return (
      <section className="causes-page pt-120 pb-120">
        <Container>
          {this.state.LoadingFlag ? <LoadingContent /> : ''}
          <div className="causes-col__3">
            {this.state.Records.map((item, index) => (
              <div className="cause-card" key={`cause-card-key-${index}`}>
                <div className="cause-card__inner">
                  <div className="cause-card__content">
                    <h3>
                      {/* <Link to={Link}>{Title}</Link> */}
                      <a href={item.SettingsValuesContent} target="_blank">
                        {item.SettingsValuesTitle}
                      </a>
                    </h3>
                    <p>{item.SettingsValuesDescription}</p>
                    <div className="cause-card__bottom">
                      <a className="thm-btn" href={item.SettingsValuesContent} target="_blank">
                        Pay Now
                      </a>
                      <a className="cause-card__share" href={item.SettingsValuesContent} target="_blank">
                        <i class="fas fa-cart-plus"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            )
            )}
          </div>
        </Container>
      </section>
    );
  };
}

export default PaymentsPage;
